import { render, staticRenderFns } from "./TelegramOtpSend.vue?vue&type=template&id=5b8d5644&"
import script from "./TelegramOtpSend.vue?vue&type=script&lang=ts&"
export * from "./TelegramOtpSend.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports